module.exports = __webpack_public_path__ + "static/media/caros-black-italic.919a4146.woff2";